import { ICreatePerformancePeriodActionPayload } from '../interfaces/create-performance-period.action.payload.interface';

export class PerformancePeriodCommand {
    start_date: string;
    end_date: string;

    constructor(query: ICreatePerformancePeriodActionPayload) {
        this.start_date = query.startDate;
        this.end_date = query.endDate;
    }
}
